module.exports = __webpack_public_path__ + "static/media/Right_Arrow.3bd66839.svg";